<template>
    <div>
        <transition name="el-fade-in-linear">
            <div class="formCard" v-show="show">
                <el-form ref="sizeForm" :model="sizeForm" :rules="rules" size="mini">
                    <i class="el-icon-close" @click="close"></i>
                    <h3 class="add">{{$t('message.addNewCard')}}</h3>
                    <el-form-item :label="$t('user.Name')" prop="name">
                        <el-input v-model="sizeForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <div class="card">
                        <el-form-item :label="$t('user.CardNumber')" class="card_num" prop="cardNumber">
                            <el-input v-model="sizeForm.cardNumber" autocomplete="off" type="number"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('user.CVV')" class="card_cvv" prop="cvv">
                            <el-input v-model="sizeForm.cvv"  autocomplete="new-password" type="password"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item :label="$t('user.ExpirationDate')" class="el-item-date" prop="date">
                        <el-select v-model="sizeForm.month" class="date-month" filterable>
                            <el-option
                                v-for="item in month_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-date-picker type="year" placeholder="2019" v-model="sizeForm.year" class="date-year" prefix-icon="el-icon-arrow-down"></el-date-picker>
                    </el-form-item>
                    <el-form-item size="large">
                        <div class="btn_submit" @click="submitForm('sizeForm')"><i class="el-icon-loading" v-if="loading"></i>{{$t('message.confirm')}}</div>
                    </el-form-item>
                </el-form>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from 'axios'
    import { Message } from 'element-ui';
    export default{
        name: 'addNewcard',
        props:{
          show: {
              type: Boolean,
              default: true
          }
        },
        data(){
            var validateCardNumber = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t('errMsg.cardNumberErr1')));
                }if (value) {
                    setTimeout(() => {
                        var reg = /^[4|5|6]\d{12,15}$/;
                        var reg2 = /^[3][7]\d{11,14}$/;
                        if (!reg.test(value) && !reg2.test(value)) {
                            callback(new Error(this.$t('errMsg.cardNumberErr2')));
                        } else {
                            callback();
                        }
                    }, 500);
                }
            };
            var validateCVV= (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t('errMsg.cvvErr1')));
                }if (value) {
                    setTimeout(() => {
                        var reg = /^\d{3,4}$/;
                        if (!reg.test(value)) {
                            callback(new Error(this.$t('errMsg.cvvErr2')));
                        } else {
                            callback();
                        }
                    }, 500);
                }
            };
            return {
                loading: false,
                sizeForm: {
                    name: '',
                    cardNumber: '',
                    cvv: '',
                    year: '2019',
                    month: 1
                },
                month_options:[
                    {
                        value: 1,
                        label: 1
                    },
                    {
                        value: 2,
                        label: 2
                    },
                    {
                        value: 3,
                        label: 3
                    },
                    {
                        value: 4,
                        label: 4
                    },
                    {
                        value: 5,
                        label: 5
                    },
                    {
                        value: 6,
                        label: 6
                    },
                    {
                        value: 7,
                        label: 7
                    },
                    {
                        value: 8,
                        label: 8
                    },
                    {
                        value: 9,
                        label: 9
                    },
                    {
                        value: 10,
                        label: 10
                    },
                    {
                        value: 11,
                        label: 11
                    },
                    {
                        value: 12,
                        label: 12
                    }
                ],
                rules: {
                    name: [
                        {required: true, message: this.$t('errMsg.cardNameErr'), trigger: 'blur'}
                    ],
                    cardNumber: [
                        { validator: validateCardNumber, trigger: ['blur','change'] }
                    ],
                    cvv: [
                        { validator: validateCVV, trigger: ['blur','change'] }
                    ],
                    year: [
                        {type: 'date',required: true, message: this.$t('errMsg.cardYearErr'), trigger: 'change'}
                    ],
                    month: [
                        {type: 'date',required: true, message: this.$t('errMsg.cardMonthErr'), trigger: 'change'}
                    ]
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        if(this.sizeForm.year== new Date().getFullYear()){
                            this.sizeForm.year = Number(this.sizeForm.year.substring(this.sizeForm.year.length - 2));
                        }else {
                            this.sizeForm.year = this.sizeForm.year.getFullYear() + '';
                            this.sizeForm.year = Number(this.sizeForm.year.substring(this.sizeForm.year.length - 2));
                        }
                        let data = {
                            creditCardInfo: {
                                name: this.sizeForm.name,
                                number: this.sizeForm.cardNumber,
                                expMonth: this.sizeForm.month,
                                expYear: this.sizeForm.year,
                                cvc: this.sizeForm.cvv,
                            }
                        }
                        axios.post('/api/payment',data).then(res=>{
                            this.loading = false;
                            Message({type: 'success',message:this.$t('message.addSuccessfully'),showClose: true});
                            this.$emit("addCard");
                            this.close();
                            this.sizeForm.month = new Date().getMonth()+1;
                            this.sizeForm.year = new Date().getFullYear()+'';
                        }).catch(err=>{
                            this.loading = false;
                            Message({type: 'error',message:err.response.data.statusCode+' '+err.response.data.message,showClose: true});
                            this.sizeForm.month = new Date().getMonth()+1;
                            this.sizeForm.year = new Date().getFullYear()+'';
                        });
                    } else {
                        Message({type: 'error',message:this.$t('errMsg.err1'),showClose: true});
                        return false;
                    }
                });
            },
            close(){
                this.$emit("close");
                this.$refs['sizeForm'].resetFields();
            }
        },
        mounted(){
            let self = this;
            this.$nextTick(function () {
                document.addEventListener('keyup', function (e) {
                    if (e.keyCode == 27) {
                        self.close();
                    }
                })
            })
        },
        created(){
            this.sizeForm.month = new Date().getMonth()+1;
            this.sizeForm.year = new Date().getFullYear()+'';
        }
    }
</script>

<style lang="scss" scoped>
    .formCard {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        z-index: 1999;
        @include flex-center;
        .add {
            font-size: 22px;
            font-weight: 900;
            margin-bottom: 15px;
        }
        .el-form {
            width: 530px;
            height: 500px;
            border: 1px solid #eee;
            background: $white;
            box-sizing: border-box;
            padding: 30px;
            @include border-radius(8px);
            position: relative;
            .el-icon-close{
                font-size: 18px;
                cursor: pointer;
                @include absolute-right-top(30px,30px);
            }
        }

        .el-icon-loading {
            margin-right: 5px;
        }

        .el-form-item__label {
            float: none;
            color: rgba(84,84,84,0.6);
            font-size: 16px;
            height: 40px;
            box-sizing: border-box;
            padding-top: 16px;
        }
        .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
            content: '';
            color: #F56C6C;
            margin-right: 4px;
        }
        .el-input__inner{
            width: 470px;
            height: 40px;
            background-color: #fcfcfc;
            border: 1px solid #c0c0c0;
            @include border-radius(5px);
        }
        .el-input--mini .el-input__inner {
            height: 40px;
            line-height: 40px;
        }
        .card {
            /* width: 470px; */
            /* height: 65px; */
            /* margin-top: 18px; */
            display: grid;
            grid-template-columns: 70% calc(30% - 8px);
            gap: 8px;
            /* @include flex-space-between; */
            ::v-deep .el-form-item__label{
                /* height: 25px; */
            }
            .card_num{
                /* .el-input__inner {
                    width: 300px;
                }
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button { -webkit-appearance: none; }
                input[type="number"]{ -moz-appearance: textfield; }
            }
            ::v-deep .card_cvv {
                ::v-deep .el-input__inner {
                    width: 150px;
                }
                ::v-deep input::-webkit-outer-spin-button,
                ::v-deep input::-webkit-inner-spin-button { -webkit-appearance: none; }
                ::v-deep input[type="number"]{ -moz-appearance: textfield; } */
            }
        }
        .el-item-date {
            /* margin-top: 22px; */
            /* height: 66px; */
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 1fr;
            justify-items: start;
            gap: 8px;
            :last-child {
                display: flex;
                width: 100%;
                :first-child {
                    width: 100%;
                    margin-right: 8px;
                }
            }
            ::v-deep .el-form-item__label {
                /* height: 26px; */
            }
            ::v-deep .el-input--mini .el-input__inner {
                height: 40px;
                width: 100px;
                margin-right: 11px;
                text-align: center;
                &::-webkit-input-placeholder {
                    color: #545454;
                }
                &:-moz-placeholder { /* Firefox 18- */
                    color: #545454;
                }

                &::-moz-placeholder { /* Firefox 19+ */
                    color: #545454;
                }

                &:-ms-input-placeholder {
                    color: #545454;
                }
            }
        }
        ::v-deep .el-select .el-input .el-select__caret {
            position: absolute;
            right: 8px;
            color: #545454;
        }
        .date-month{
            position: relative;
            ::v-deep .el-icon-arrow-up:before {
                /*content: "\E60C";*/
            }
        }
        .date-year{
            cursor: pointer;
            position: relative;
            ::v-deep .el-input__icon {
                color: #545454;
                font-size: 14px;
                @include absolute-left-bottom(70px,0);
            }
        }
        .btn_submit{
            width: 470px;
            height: 52px;
            margin: 36px 0 58px;
            font-size: 19px;
            color: $white;
            background: $primary-color;
            @include border-radius(28px);
            font-weight: 900;
            cursor: pointer;
            text-align: center;
            line-height: 52px;
        }
    }
    @media screen and (max-width: 450px){
        .formCard{
            ::v-deep .el-form{
                width: 84vw;
                max-height: 80vh;
                height: auto;
                overflow-y: auto;
                .el-icon-close{
                    top: 36px;
                }
            }

            ::v-deep .el-form-item__label{
                float: none;
                color: rgba(84,84,84,0.6);
                font-size: 16px;
                height: 40px;
                box-sizing: border-box;
                padding-top: 16px;
            }
            ::v-deep .el-input__inner{
                width: 100%;
            }
            .card{
                width: 100%;
                height: auto;
                display: block;
                ::v-deep .el-form-item__label{
                    float: none;
                    color: rgba(84,84,84,0.6);
                    font-size: 16px;
                    height: 40px;
                    box-sizing: border-box;
                    padding-top: 16px;
                }
                .card_num,.card_cvv{
                    ::v-deep .el-input__inner{
                        width: 100%;
                    }
                }
            }
            ::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
                width: 60px;
            }
            .date-month{
                margin-bottom: 10px;
            }
            .btn_submit{
                width: 100%;
                margin: 36px 0 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/settings/addNewcard.vue